var utils = {
    log: function(object) {
        if (process.env.NODE_ENV !== "production") {
            console.log(object);
        }
    }
};

export { utils }
